import { render, staticRenderFns } from "./SubcategoriesProductsFilter.vue?vue&type=template&id=2ec8e152&lang=pug"
import script from "./SubcategoriesProductsFilter.vue?vue&type=script&lang=js"
export * from "./SubcategoriesProductsFilter.vue?vue&type=script&lang=js"
import style0 from "./SubcategoriesProductsFilter.vue?vue&type=style&index=0&id=2ec8e152&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports